export const fmtEUR = (value, opts = {}) => {
  const { signed = false, digits = 2 } = opts;
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const abs = Math.abs(value).toLocaleString("de-DE", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  const sign = value > 0 ? "+" : value < 0 ? "−" : "";
  return `${signed ? sign : value < 0 ? "−" : ""}${abs} €`;
};

export const fmtPct = (value, opts = {}) => {
  const { signed = true, digits = 1 } = opts;
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const abs = Math.abs(value).toFixed(digits);
  const sign = value > 0 ? "+" : value < 0 ? "−" : "";
  return `${signed ? sign : value < 0 ? "−" : ""}${abs}\u00A0%`;
};

export const fmtNum = (value, digits = 2) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return Number(value).toLocaleString("de-DE", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("de-DE", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
